<template>
  <div>
    <b-card class="col-12" no-body>
      <div class="m-2">
        <b-row>
          <b-col cols="12">
            <h4>
              Khách hàng tham gia Vpbank
              <a
                  v-b-tooltip.hover.top="'Lấy lại danh sách!'"
                  class="btn-icon"
                  @click="$router.go()"
              >
                <feather-icon icon="RepeatIcon"
                />
              </a>
            </h4>
          </b-col>
        </b-row>
        <validation-observer ref="modalEdit">
          <div class="p-1">
            <b-row>
              <b-col cols="12" md="3">
                <validation-provider #default="{ errors }" name="Từ ngày">
                  <b-form-group label="Từ ngày">
                    <b-input-group label="Từ ngày">
                      <b-form-datepicker
                          v-model="serverParams.startDate"
                          :date-format-options="{
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric',
                        }"
                          :state="errors.length > 0 ? false : null"
                          close-button
                          locale="vi-VN"
                          reset-button
                          today-button
                      />
                    </b-input-group>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="3">
                <validation-provider #default="{ errors }" name="Đến ngày">
                  <b-form-group label="Đến ngày">
                    <b-input-group label="Đến ngày">
                      <b-form-datepicker
                          v-model="serverParams.endDate"
                          :date-format-options="{
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric',
                        }"
                          :state="errors.length > 0 ? false : null"
                          close-button
                          locale="vi-VN"
                          reset-button
                          today-button
                      />
                    </b-input-group>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="3">
                <validation-provider name="Họ tên KH">
                  <b-form-group label="Họ tên KH">
                    <b-form-input
                        v-model="serverParams.fullName"
                        placeholder="Họ tên KH"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="3">
                <validation-provider name="Số điện thoại">
                  <b-form-group label="Số điện thoại">
                    <b-form-input
                        v-model="serverParams.sdt"
                        placeholder="Số điện thoại"
                        type="number"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </div>
        </validation-observer>
        <b-row>
          <b-col cols="9">
            <b-tabs>
              <b-tab
                  v-for="(s, idx) in status"
                  :key="idx"
                  :active="serverParams.status === s.value"
                  :title="s.text"
                  @click="changeTab(s.value)"
              >
              </b-tab>
            </b-tabs>
          </b-col>
          <b-col class="text-end mb-2" cols="3">
            <vue-excel-xlsx
                :columns="fields.filter((el) => el.label != 'Action')"
                :data="exportExcelData"
                :file-name="'Thống kê đơn hàng'"
                :file-type="'xlsx'"
                :sheet-name="'sheetname'"
                class="border-0 bg-transparent"
            >
              <b-button class="btn" variant="primary"> Export</b-button>
            </vue-excel-xlsx>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <vue-good-table
                :columns="fields"
                :isLoading.sync="isLoading"
                :line-numbers="true"
                :pagination-options="{ perPage: serverParams.pageSize, enabled: true }"
                :rows="tableData"
                :totalRows="totalRecords"
                class="vpbank-tb-container"
                mode="remote"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-per-page-change="onPerPageChange"
            >
              <template slot="table-row" slot-scope="props">
                <!-- Column: Action -->
                <span
                    v-if="
                    props.column.field === 'action' &&
                    (props.row['status'] === null || props.row['status'] === '')
                  "
                    class="action-container"
                >
                  <b-button class="btn-icon" size="sm" variant="primary">
                    Phê duyệt
                  </b-button>
                  <b-button class="btn-icon" size="sm" variant="primary">
                    Từ chối
                  </b-button>
                </span>
                <span
                    v-else-if="
                    props.column.field === 'CreateDate' ||
                    props.column.field === 'activatedDate' ||
                    props.column.field === 'CallDate' ||
                    props.column.field === 'createdDate'
                  "
                >
                  {{ getDateTime(props.formattedRow[props.column.field]) }}
                </span>
                <span v-else-if="props.column.field === 'status'">
                  <!-- {{
                    status.find(
                      (item) => item.id == props.formattedRow[props.column.field]
                    ) &&
                    status.find(
                      (item) => item.id == props.formattedRow[props.column.field]
                    ).text
                  }} -->
                  {{ props.row["status"] === null ? "" : props.row["statusText"] }}
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>
<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import vSelect from "vue-select";
import {VueGoodTable} from "vue-good-table";
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCardText,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
  BTooltip,
  VBTooltip,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import "@core/scss/vue/libs/vue-good-table.scss";
import Select2 from "v-select2-component";
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import Vue from "vue";
import VueExcelXlsx from "vue-excel-xlsx";

Vue.use(VueExcelXlsx);

export default {
  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    BTabs,
    BTab,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BFormTextarea,
    BCardText,
    BInputGroup,
    flatPickr,
  },

  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  async mounted() {
    await this.getOutBound();
    await this.getTabTableData();
  },
  computed: {
    groupId() {
      if (!this.group || this.group.length == 0) return 0;
      return this.group[0].ID;
    },
    flowId() {
      return this.selectedTab;
    },
    disabledModalField() {
      return (
          this.selectedRecord &&
          (this.selectedRecord.Status === 2 || this.selectedRecord.Status === 3)
      );
    },
    exportExcelData() {
      let data = this.exportTableData || [];

      return data.map((el) => {
        return {
          ...el,
          Status: (this.status.find((o) => o.value == el.Status) || {text: ""}).text,
        };
      });
    },
  },
  watch: {
    callStatusSelected(newValue, oldValue) {
    },
    serverParams: {
      immediate: true,
      deep: true,
      handler(val, oldVal) {
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
          this.getTabTableData();
        }, 500);
      },
    },
  },
  methods: {
    updateParams(newProps) {
      //TODO: check params
      // this.serverParams = Object.assign({}, this.serverParams, newProps);
      // console.log("newProps", newProps, this.serverParams);
      // if (this.serverParams.columnFilters.status == "") {
      //   delete this.serverParams.columnFilters.status;
      // }
    },
    async handleOk(bvModalEvt) {
      if (bvModalEvt) {
        bvModalEvt.preventDefault();
      }

      if (this.selectedRecord.Status === 2) {
        this.$bvModal.hide("activated-order-modal");
        return;
      }

      var validate = await this.$refs.modalView.validate().then((success) => {
        return success;
      });
      if (!validate) {
        this.$toast.warning("Vui lòng nhập các trường thông tin bắt buộc", {
          icon: true,
          closeButton: "button",
        });
        return;
      }
      let data = {
        obid: this.selectedRecord.ID,
        // "appointmentTime": "",
        callStatus: this.callStatusSelected,
        note: this.detailQuestionExtra.Note,
        // "results": {}
      };
      if (this.callStatusSelected == 0) {
        data.appointmentTime = this.appointmentTime;
      } else {
        data.results = {};
        this.detailQuestions.forEach((el) => {
          data.results[el.id] = el.value;
        });
      }
      useJwt
          .post("ob/submit", data)
          .then(async (response) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Cập nhật thành công!",
                icon: "CheckSquareIcon",
                variant: "success",
              },
            });
            await this.getTabTableData();
            this.$bvModal.hide("activated-order-modal");
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Lỗi cập nhật [" + error.response.data.result + "]!",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          });
    },
    onSelectOrderTime(val) {
      if (this.selectedOrderTime != val) {
        this.selectedOrderTime = val;
      }
    },
    async onPageChange(params) {
      this.serverParams.page = params.currentPage;
      await this.getTabTableData();
    },
    onSortChange(params) {
      this.updateParams(params);
      // this.getTabTableData(false);
    },
    async onPerPageChange(params) {
      this.serverParams.pageSize = params.currentPerPage;
    },
    onConfirm1() {
    },
    onFailure1() {
    },
    onConfirm2() {
    },
    onFailure2() {
    },
    async onShowDetailModal(row) {
      this.callStatusSelected = 1;
      this.appointmentTime = null;
      this.selectedRecord = JSON.parse(JSON.stringify(row));
      await this.getDetailData(row.ID);
      this.$bvModal.show("activated-order-modal");
    },
    async getOutBound() {
      this.flow = [
        {ID: 0, Name: "Tất cả"},
        {ID: 1, Name: "Đủ điều kiện"},
        {ID: 2, Name: "Không đủ điều kiện"},
      ];
    },
    getFieldsTable(columns) {
      this.fields = columns.map((c) => {
        const key = Object.keys(c)[0];
        if (key === "status") {
          return {
            field: key,
            filterOptions: {
              enabled: false,
              placeholder: "",
              filterDropdownItems: this.status.map((el) => {
                return {...el, value: el.id};
              }),
            },
            label: c[key],
            required: true,
            disabled: true,
            tdClass: "text-center",
          };
        } else if (key === "action") {
          return {
            field: key,
            filterOptions: {enabled: false, placeholder: ""},
            label: c[key],
            required: true,
            disabled: true,
            tdClass: "text-center",
            width: "300px",
          };
        } else {
          return {
            field: key,
            filterOptions: {enabled: false, placeholder: ""},
            label: c[key],
            required: true,
            disabled: true,
            tdClass: "text-center",
            width:
                key === "ID"
                    ? "50px"
                    : key === "ContactNumber"
                        ? "100px"
                        : key === "CallTimes"
                            ? "70px"
                            : "auto",
          };
        }
      });
    },
    async getTabTableData(isGetColumn = true) {
      const response = await useJwt.post(`InforCusVpBank`, this.serverParams);
      if (response.data.code === 200) {
        this.tableData = response.data.result;
        this.totalRecords = response.data.totalRecords;
      } else {
        this.tableData = [];
        this.totalRecords = 0;
      }
      const column = [
        {fullName: "Họ tên KH (Nhập ban đầu) "},
        {contactPhone: "Số điện thoại (Nhập ban đầu) "},
        {email: "Email (Nhập ban đầu) "},
        {createdDate: "Ngày tạo"},
        {status: "Trạng thái"},
        {action: "Phê duyệt"},
      ];
      this.getFieldsTable(column);
    },
    async changeTab(e) {
      this.serverParams.status = e;
      // this.selectedTab = e;
      // await this.getTabTableData();
      //TODO: on change tab
    },
    getDateTime(e) {
      return moment(e).isValid() ? moment(e).format("DD/MM/YYYY HH:mm:ss") : "";
    },
    async getDetailData(id) {
      const response = await useJwt.get(`ob/detail/${id}`);
      if (response.data.code == 200) {
        const results = response.data.extra.Results || {};

        this.detailQuestions = response.data.result.map((el) => {
          return {
            ...el,
            value:
                this.selectedRecord.Status === 2 || this.selectedRecord.Status === 3
                    ? results[el.id]
                    : null,
          };
        });
        this.detailQuestionExtra = response.data.extra;
        this.detailColumnExtra = response.data.extra.DetailColumn.map((el) => {
          let key = Object.keys(el)[0];
          let label = el[key];
          return {key, label};
        });
      } else {
        this.detailQuestions = [];
        this.detailQuestionExtra = {};
        this.detailColumnExtra = [];
      }
    },
  },
  data() {
    return {
      appointmentTime: null,
      callStatusSelected: 1,
      detailColumnExtra: [],
      selectedTab: 0,
      selectedOrderTime: 0,
      serverParams: {
        columnFilters: {},
        sort: [],
        page: 1,
        pageSize: 50,
        fullName: "",
        status: "",
        sdt: "",
        startDate: "",
        endDate: "",
      },
      totalRecords: 0,
      isLoading: false,
      flow: [],
      callStatus: [],
      group: [],
      questionType: [],
      status: [
        {
          value: "",
          text: "Tất cả",
        },
        {
          value: 1,
          text: "Đủ điều kiện",
        },
        {
          value: 0,
          text: "Không đủ điều kiện",
        },
      ],
      tableData: [],
      exportTableData: [],
      selectedRecord: null,
      detailQuestions: [],
      detailQuestionExtra: {},
      fields: [
        {
          field: "action",
          filterOptions: {enabled: false, placeholder: ""},
          label: "Action",
          required: true,
          disabled: true,
          width: "100px",
        },
      ],
      timeOut: null,
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.modal-activated-order {
  height: 700px;
  color: #000000;
}

.col-700-scroll {
  height: 680px;
  overflow: auto;
}

.vpbank-tb-container .line-numbers,
th.vgt-left-align {
  background: linear-gradient(#f4f5f8, #f1f3f6) !important;
}

.vpbank-tb-container td {
  height: 34.4px !important;
}
</style>
<style scoped>
.error-txt small {
  color: red;
}

.unselected {
  background: rgb(175, 175, 175) !important;
  border: rgb(175, 175, 175) !important;
}

.text-end {
  text-align: end;
}

.action-col {
  width: 100%;
  display: flex;
  justify-content: center;
}

.order-id:hover {
  cursor: pointer;
  font-weight: bold;
  color: rgb(34, 100, 243);
}

.detail-custom-table {
  width: 100%;
}

.detail-custom-table {
  display: inline-table;
  border: solid 1px rgb(207 207 207);
}

.detail-custom-table th,
.detail-custom-table td {
  border: solid 1px rgb(207 207 207);
  padding: 5px 10px;
}

.detail-custom-table th {
  vertical-align: baseline;
}

.history-call__header {
  display: flex;
  justify-content: space-between;
  padding: 20px;
}

.history-call__header h5 {
  margin: 0;
}

.note-question {
  font-style: italic;
  color: rgb(233, 71, 22);
  margin-bottom: 9px;
}

.action-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.action-container button {
  margin: 0 10px;
}
</style>
